function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 4)",
  stroke: "#2B9D8B",
  strokeWidth: 1.8,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 14.222c0 .982-.806 1.778-1.8 1.778H1.8C.806 16 0 15.204 0 14.222V4.444c0-.977.81-1.777 1.8-1.777h2.7L6.3 0h5.4l1.8 2.667h2.7c.994 0 1.8.796 1.8 1.777v9.778z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 8.889,
  rx: 3.6,
  ry: 3.556
}));

function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8eee82cc.svg";
export { ForwardRef as ReactComponent };